var exports = {
  "ZZ": "field__oaMJ3t",
  "Pf": "label__SNIpjr",
  "Uq": "value__FAeZhc",
};

module.exports = exports;
